
(function () {
    'use strict';

    angular.module(modules.homeModule)
        .controller('annualCycleDetailController', controller)
        .filter('activitiesByMonthFilter', activitiesByMonthFilter)
        .filter('activitiesBySchoolYearMonthFilter', activitiesBySchoolYearMonthFilter);

    controller.$inject = ['$rootScope', '$scope', '$http', '$stateParams', 'uiGridConstants', '$state', '$timeout', 'configService', '$anchorScroll', '$location', '$sce', '$uibModal', 'npDialog'];
    function controller($rootScope, $scope, $http, $stateParams, uiGridConstants, $state, $timeout, configService, $anchorScroll, $location, $sce, $modal, npDialog) {
        $scope.translation = globalResources;
        var yearRange = 11;

        var vm = this;
        vm.activities = [];
        vm.periods = getPeriods(yearRange);
        vm.periodsForSchoolYear = getPeriodsForSchoolYear(yearRange);

        vm.model = {
            name: '',
            description: '',
            viewType: -1,
            partitioning: 1
        };

        vm.monthViews = [];
        vm.schoolYearMonthViews = [];
        vm.cycleMonths = [];
        vm.cycleSchoolMonths = [];
        vm.activityTasks = [];
        vm.listActivitiesInView = [];
        vm.isExpandAll = false;

        vm.changeView = changeView;
        vm.resolveColor = resolveColor;
        vm.resolveSchoolYearColor = resolveSchoolYearColor;
        vm.print = print;
        vm.close = close;
        vm.expandActivityRow = expandActivityRow;
        vm.expandAllTasksInActivity = expandAllTasksInActivity;
        vm.expandAllItems = expandAllItems;
        vm.initListActivitiesGrid = initListActivitiesGrid;
        vm.scrollToMonth = scrollToMonth;
        vm.getActivityDetailUrl = getActivityDetailUrl;
        vm.getTaskDetailUrl = getTaskDetailUrl;
        vm.alerts = [];
        vm.canExpandAll = true;
        
        init();

        function close() {
            window.close();
        }

        function print() {
            window.open(String.format('/Printing/PrintAnnualCycleDetail?annualCycleId={0}&viewType={1}&period={2}', vm.model.annualCycleId, vm.model.viewType, vm.model.period));
        }

        function resolveColor(month, partitioning) {
            if (partitioning == 1)
                return 'color-blue';
            else if (partitioning == 2) {
                if (month >= 1 && month < 4)
                    return 'color-blue';
                else if (month >= 4 && month < 7)
                    return 'color-green';
                else if (month >= 7 && month < 10)
                    return 'color-orange';
                else
                    return 'color-purple';
            }
            else if (partitioning == 3) {
                if (month >= 1 && month < 5)
                    return 'color-blue';
                else if (month >= 5 && month < 9)
                    return 'color-green';
                else
                    return 'color-orange';
            }
        }

        function resolveSchoolYearColor(month, partitioning) {
            if (partitioning == 1)
                return 'color-blue';
            else if (partitioning == 2) {
                if (month == 9 || month == 10 || month == 11)
                    return 'color-blue';
                else if (month == 12 || month == 1 || month == 2)
                    return 'color-green';
                else if (month == 3 || month == 4 || month == 5)
                    return 'color-orange';
                else
                    return 'color-purple';
            }
            else if (partitioning == 3) {
                if (month == 9 || month == 10 || month == 11 || month == 12)
                    return 'color-blue';
                else if (month == 1 || month == 2 || month == 3 || month == 4)
                    return 'color-green';
                else
                    return 'color-orange';
            }
            else if (partitioning == 4) {
                if (month == 8 || month == 9 || month == 10 || month == 11 || month == 12)
                    return 'color-blue';
                else if (month == 1 || month == 2 || month == 3 || month == 4 || month == 5)
                    return 'color-green';
                else
                    return 'color-orange';
            }
        }

        function changeView() {
            if (vm.model.viewType == 0) {
                vm.model.viewType = 1;
            }
            else if (vm.model.viewType == 1) {
                vm.model.viewType = 0;
            }
		}

		var getDaysInMonth = function (month, year) {
			return new Date(year, month, 0).getDate();
		};


        function init() {
            $http.get('/api/annualCycle/getAnnualCycle/' + $stateParams.id).then(function (response) {
                if (!response.data) {
                    return;
                }
                var data = response.data;
                vm.model.annualCycleId = data.annualCycleId;
                vm.model.name = data.name;
                vm.model.description = data.description;
                vm.model.partitioning = data.partitioning;
                vm.model.viewType = data.viewType;
                vm.model.isSchoolYear = data.isSchoolYear;
                vm.model.period = data.year;

                if (vm.model.period) {
                    vm.isDisablePeriod = true;
                    vm.model.period = parseInt(vm.model.period);
                } else {
                    vm.model.period = (new Date()).getFullYear();
                }

				var activities = [];
				if (data.activities.length) {
					data.activities.forEach(function (activity) {
                        var sDate = new Date(activity.startDate);
                        var eDate = new Date(activity.endDate);
                        var sDate_Date = sDate.getDate();
                        var sDate_Month = sDate.getMonth();
                        var sDate_Year = sDate.getFullYear();
                        var eDate_Date = eDate.getDate();
                        var eDate_Month = eDate.getMonth();
                        var eDate_Year = eDate.getFullYear();
                        activity.startYear = sDate_Year;
                        activity.tooltip = '';
                        
                        if (activity.description) {
                            activity.tooltip = '<div><label class"tool-tip-label">' + globalResources.Description + ':</label><div>' + activity.description.replace(/\n/g, "<br />") + '</div></div>';
                        }
                        
                        if (activity.responsibleNames) {
                            activity.tooltip = activity.tooltip + (activity.description ? '<br />' : '') + '<div><label class"tool-tip-label">' + globalResources.Responsible + ':</label><div>' + activity.responsibleNames + '</div></div>';
                        }

                        activity.tooltip = $sce.trustAsHtml(activity.tooltip);

                        activity.isStartAndEndInTheSameMonth = (sDate_Month == eDate_Month) && (sDate_Year == eDate_Year);
						activity.isStartAndEndInTheSameDay = (sDate_Date == eDate_Date) && (sDate_Month == eDate_Month) && (sDate_Year == eDate_Year);

                        activity.percentageTasksCompleted = Math.round(activity.numberTasksDone / activity.numberTotalTasks * 100);

						if ((sDate_Month != eDate_Month) || (sDate_Year != eDate_Year)) {
							var numberLoop = (eDate_Year != sDate_Year) ? Math.abs((12 - sDate_Month + eDate_Month + 1) + 12 * (eDate_Year - sDate_Year - 1))
								: eDate_Month - sDate_Month + 1;
							var year = sDate_Year;
							var month = sDate_Month;//Month start from index 0
							for (var i = 0; i < numberLoop; i++) {
								var activityTemp = angular.copy(activity);
								if (month > 11) {
									month = month - 12;
									year = year + 1;
								}
								if (month == sDate_Month && year == sDate_Year) {
									var day = getDaysInMonth(month + 1, year);
									activityTemp.endDate = new Date(year, month, day);
									activityTemp.isStartAndEndInTheSameDay = (sDate_Date == day);
								} else if (month == eDate_Month && year == eDate_Year) {
									activityTemp.startDate = new Date(year, month, 1);
									activityTemp.isStartAndEndInTheSameDay = (eDate_Date == 1);
								} else {
									var day = getDaysInMonth(month + 1, year);
									activityTemp.startDate = new Date(year, month, 1);
									activityTemp.endDate = new Date(year, month, day);
								}
								activityTemp.isStartAndEndInTheSameMonth = true;
								activities.push(activityTemp);

								month = month + 1;
							}
						} else {
							activities.push(activity);
						}

                    });
                }

				vm.activities = activities;

                vm.readingListReaders = data.readers;
                vm.readingListExclusions = data.exclusions;
                //updateReadingListReaderTypes(vm.readingListReaders);

                $rootScope.title += ' : ' + vm.model.name;
                $rootScope.description = vm.model.description;

                getAccessibleActivitiTasks();

                initCycleMonths();
            })
            .catch(err => {
                vm.alerts.unshift({ type: 'danger', message: globalResources.NotExistOrNoPermission });
            });
        }

        function getAccessibleActivitiTasks() {
            $http.get('/api/Activity/GetAccessibleActivityTasksInAnnualCycle?annualCycleId=' + $stateParams.id)
                .success(function (data) {
                    if (data) {
                        vm.activityTasks = (data || []).map(x => {
                            var taskResponsibles = [];
                            if (x.taskResponsibles && x.taskResponsibles.length) {
                                x.taskResponsibles.forEach(item => {
                                    if (item.responsibleId == 0) {
                                        taskResponsibles.push(globalResources.AllResponsible);
                                    } else if (item.responsibleId == -1) {
                                        taskResponsibles.push(globalResources.ActivityResponsible);
                                    } else {
                                        taskResponsibles.push(item.responsibleName);
                                    }
                                });
                            }
                            x.responsibleName = taskResponsibles.join(', ');

                            x.descriptionDisplay = x.description ? x.description.replace(/\n/g, "<br />") : '';
                            x.statusDisplay = generateStatusText(x.status);
                            
                            return x;
                        });
                        initListView();

                    }
                });
        }

        function initListView() {
            if (!vm.model.isSchoolYear) {
                vm.monthViews.push({ id: 1, name: globalResources.January });
                vm.monthViews.push({ id: 2, name: globalResources.February });
                vm.monthViews.push({ id: 3, name: globalResources.March });
                vm.monthViews.push({ id: 4, name: globalResources.April });
                vm.monthViews.push({ id: 5, name: globalResources.May });
                vm.monthViews.push({ id: 6, name: globalResources.June });
                vm.monthViews.push({ id: 7, name: globalResources.July });
                vm.monthViews.push({ id: 8, name: globalResources.August });
                vm.monthViews.push({ id: 9, name: globalResources.September });
                vm.monthViews.push({ id: 10, name: globalResources.October });
                vm.monthViews.push({ id: 11, name: globalResources.November });
                vm.monthViews.push({ id: 12, name: globalResources.December });
                initListActivitiesGrid(vm.monthViews);
            }
            else {
                vm.schoolYearMonthViews.push({ id: 8, name: globalResources.August });
                vm.schoolYearMonthViews.push({ id: 9, name: globalResources.September });
                vm.schoolYearMonthViews.push({ id: 10, name: globalResources.October });
                vm.schoolYearMonthViews.push({ id: 11, name: globalResources.November });
                vm.schoolYearMonthViews.push({ id: 12, name: globalResources.December });
                vm.schoolYearMonthViews.push({ id: 1, name: globalResources.January });
                vm.schoolYearMonthViews.push({ id: 2, name: globalResources.February });
                vm.schoolYearMonthViews.push({ id: 3, name: globalResources.March });
                vm.schoolYearMonthViews.push({ id: 4, name: globalResources.April });
                vm.schoolYearMonthViews.push({ id: 5, name: globalResources.May });
                vm.schoolYearMonthViews.push({ id: 6, name: globalResources.June });
                vm.schoolYearMonthViews.push({ id: 7, name: globalResources.July });
                initListActivitiesGrid(vm.schoolYearMonthViews, true);
            }
            setTimeout(function () {
                scrollToMonth($location.$$hash)
            }, 0)
        }

        function initListActivitiesGrid(monthViews, isSchoolYear = false) {
            vm.listActivitiesInView = [];
            monthViews.forEach(item => {
                item.isExpandAllTasks = false;
                item.activitiesGrid = {
                    expandableRowTemplate: '/app/components/annualCycle/templates/annualCycleDetail.activityTasksRowTemplate.html',
                    showExpandAllButton: false,
                    enableExpandableRowHeader: false,
                    enableOnDblClickExpand: false,
                    expandableRowHeight: 'auto',
                    columnDefs: [
                        {
                            field: 'startDate', displayName: item.name,
                            enableSorting: false,
                            width: '10%',
                            cellTemplate: `
									<div style="padding-left: 15px;">
										{{row.entity.startDate | date : 'dd'}}
										<span ng-if="row.entity.isStartAndEndInTheSameMonth && !row.entity.isStartAndEndInTheSameDay">-{{row.entity.endDate | date : 'dd'}}</span>
									</div>
									`
                        },
                        {
                            field: 'name', displayName: globalResources.Activity,
                            width: '17%',
                            cellTemplate: `
									<div class="ui-grid-cell-contents font-bold">
                                        <a class="hover-as-link text-black" ng-href="{{grid.appScope.vm.getActivityDetailUrl(row.entity.activityId)}}" target="_self">{{row.entity.name}}</a>
									</div>
									`
                        },
                        {
                            field: 'description',
                            displayName: globalResources.Description,
                            cellTemplate: `
									<div class="ui-grid-cell-contents">
										<div class="multi-line-text">{{row.entity.description}}</div>
								    </div>
									`
                        },
                        {
                            field: 'responsibleName', displayName: globalResources.Responsible,
                            width: '10%',
                            cellTemplate: `
								<div class="ui-grid-cell-contents">
									<div>
										{{row.entity.responsibleName}}
									</div>
									<div class="fs11 dialog-inform-cl margin-bottom-10">
										{{grid.appScope.translation.ActivityResponsible}}
									</div>
								</div>
							`
                        },
                        {
                            field: 'responsibleNames', displayName: '',
                            width: '10%',
                            cellTemplate: `
							<div class="ui-grid-cell-contents">
								<div>
									{{row.entity.responsibleNames}}
								</div>
								<div ng-if="row.entity.responsibleNames" class="fs11 dialog-inform-cl margin-bottom-10">
									{{grid.appScope.translation.MainResponsible}}
								</div>
							</div>
							`
                        },
                        {
                            field: 'status', displayName: 'Status',
                            width: '10%',
                            enableSorting: false,
                            cellTemplate: `
								<div class="ui-grid-cell-contents">
									<div class="progress">
										<div class="progress-bar" role="progressbar" aria-valuenow="60" aria-valuemin="0"
											 ng-class="{
                                                        'bg-img-none' : row.entity.numberTotalTasks != 0,
                                                        'progress-bar-no-color': row.entity.numberTotalTasks == 0,
                                                        'progress-bar-bg-danger': row.entity.numberTotalTasks != 0 && row.entity.numberTasksDone == 0,
														'progress-bar-bg-success' : row.entity.numberTotalTasks != 0 && row.entity.numberTasksDone == row.entity.numberTotalTasks,
														'progress-bar-bg-warning' : row.entity.numberTasksDone != 0 && row.entity.numberTasksDone < row.entity.numberTotalTasks }"
											 aria-valuemax="100" style="width: {{row.entity.percentageTasksCompleted != 0 ? row.entity.percentageTasksCompleted : 100}}%; background-image: none;">
										</div>
									</div>
									<div>
										{{row.entity.numberTasksDone}}/{{row.entity.numberTotalTasks}}
									</div>
								</div>
									`
                        },
                        {
                            field: 'document', displayName: '',
                            width: '45',
                            enableSorting: false,
                            cellTemplate: `app/components/annualCycle/templates/taskAttachmentsTooltip.html`
                        },
                        {
                            field: 'expand', displayName: '', width: '45', enableSorting: false,
                            headerCellTemplate:
                                `<div class="expand-measure pt10">
									<span ng-if="grid.appScope.$parent.month.hasTasks"
                                        ng-click="grid.appScope.vm.expandAllTasksInActivity(grid.appScope.$parent.month, grid);" class="pointer">
										<i class="tc-white" ng-class="{'fa fa-angle-down': !grid.appScope.$parent.month.isExpandAllTasks, 'fa fa-angle-up': grid.appScope.$parent.month.isExpandAllTasks }"></i>
									</span>
								</div>`,
                            cellTemplate: `<div class="expand-measure" ng-if="row.entity.numberTotalTasks > 0">
							<span class="pointer"
								  ng-click="grid.appScope.vm.expandActivityRow(row.entity, grid, grid.appScope.$parent.month)">
								<i class="fa fa-angle-down" ng-if="!row.isExpanded"></i>
								<i class="fa fa-angle-up" ng-if="row.isExpanded"></i>
							</span>
                        </div>`
                        }
                    ],
                    enableColumnMenus: false,
                    onRegisterApi: function (gridApi) {
                        vm.gridApi = gridApi;
                    }
                };
                item.activitiesGrid.onRegisterApi = function (gridApi) {
                    item.gridApi = gridApi;
                    item.gridApi.core.on.sortChanged($scope, function (grid, sortColumns) {
                        // Find the monthView model of the grid on which we are sorting
                        var monthViewItem = null;
                        if (vm.model.isSchoolYear) {
                            monthViewItem = vm.schoolYearMonthViews.find(mv => {
                                if (mv.gridApi) {
                                    return mv.gridApi.grid.id == grid.id;
                                }
                                return false;
                            });
                        }
                        else {
                            monthViewItem = vm.monthViews.find(mv => {
                                if (mv.gridApi) {
                                    return mv.gridApi.grid.id == grid.id;
                                }
                                return false;
                            });
                        }
                        if (!monthViewItem) { return; }
                        var expandedRows = collapseMonthViewSaveState(monthViewItem, monthViewItem.gridApi.grid);
                        $timeout(function () {
                            expandedRows.forEach(row => {
                                monthViewItem.gridApi.grid.api.expandable.toggleRowExpansion(row);
                            });
                        });
                    });
                };
                item.activitiesGrid.data = isSchoolYear ? filterActivitiesBySchoolYearMonth(vm.activities, item.id, vm.model.period) : filterActivitiesByMonth(vm.activities, item.id, vm.model.period);
                item.activitiesGrid.enableHorizontalScrollbar = uiGridConstants.scrollbars.NEVER;
                item.activitiesGrid.enableVerticalScrollbar = uiGridConstants.scrollbars.NEVER;
                if (item.activitiesGrid.data.length > 0) {
                    if (item.activitiesGrid.data.some(activity => activity.numberTotalTasks > 0)) {
                        item.hasTasks = true;
                    }
                    vm.listActivitiesInView = angular.copy(vm.listActivitiesInView).concat(item.activitiesGrid.data);
                }

                item.activitiesGrid.data.forEach(activity => {
                    activity.hasDocument = activity.activityDocuments && !!activity.activityDocuments.length;
                    if (activity.hasDocument) {
                        activity.onShowDialogActivityDocument = (entity) => {
                            var modalInstance = $modal.open({
                                templateUrl: '/app/components/annualCycle/templates/activity.gridViewModal.html',
                                controller: 'activityGridViewModalController as vm',
                                size: 'lg',
                                backdrop: 'static',
                                resolve: {
                                    model: function () {
                                        return {
                                            data: entity
                                        }
                                    }
                                }
                            });
                        }
                    }
                    initActivityTasksGrid(activity);
                });
            });
            if (!vm.listActivitiesInView.some(item => item.numberTotalTasks > 0)) {
                vm.canExpandAll = false;
                if (vm.listActivitiesInView.length > 0) {
                    monthViews.forEach(item => {
                        var statusCol = item.activitiesGrid.columnDefs.find(col => col.field === 'status');
                        if (statusCol) {
                            statusCol.visible = false;
                        }
                    });
                }
            }
            else {
                vm.canExpandAll = true;
            }
        }

        function scrollToMonth(monthId) {
            const ele = document.getElementById(monthId);
            if (ele) {
                ele.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start'
                });
            }
        }


        function expandActivityRow(entity, grid, monthViewItem) {
            grid.api.expandable.toggleRowExpansion(entity);
            monthViewItem.isExpandAllTasks = monthViewItem.gridApi.grid.rows.every(item => item.isExpanded == true);
        }

        function expandAllTasksInActivity(monthViewItem, grid) {
            monthViewItem.isExpandAllTasks = !monthViewItem.isExpandAllTasks;

            monthViewItem.gridApi.grid.rows.forEach(row => {
                if (row.isExpanded != monthViewItem.isExpandAllTasks) {
                    grid.api.expandable.toggleRowExpansion(row.entity);
                }
            });
        }
            
        function expandAllItems(listMonthViews) {
            vm.isExpandAll = !vm.isExpandAll;
            listMonthViews.forEach(monthViewItem => {
                if (monthViewItem.activitiesGrid.data.length > 0 && monthViewItem.isExpandAllTasks != vm.isExpandAll) {
                    monthViewItem.isExpandAllTasks = !monthViewItem.isExpandAllTasks;
                    if (vm.isExpandAll) {
                        monthViewItem.gridApi.expandable.expandAllRows();
                    }
                    else {
                       monthViewItem.gridApi.expandable.collapseAllRows();
                    }
                }
            });
        }

        // Collapse all activity rows in a grid and return rows that were expanded before
        function collapseMonthViewSaveState(monthViewItem, grid) {
            var expandedRows = [];
            monthViewItem.gridApi.grid.rows.forEach(row => {
                if (row.isExpanded) {
                    expandedRows.push(row.entity);
                    grid.api.expandable.toggleRowExpansion(row.entity);
                }
            });
            return expandedRows;
        }

        function initActivityTasksGrid(activity) {
            activity.subGridOptions = {
                showHeader: false,
                columnDefs: [
                    {
                        field: 'startDate',
                        enableSorting: false,
                        width: '10%',
                        cellTemplate: `
									<div style="padding-left: 15px;">
										{{row.entity.endDateDisplay}}
									</div>
									`

                    },
                    {
                        field: 'name',
                        width: '17%',
                        cellTemplate: `
									<div class="ui-grid-cell-contents font-bold">
										<a class="hover-as-link text-black" ng-href="{{grid.options.expandableRowScope.getTaskDetailUrl(row.entity.activityTaskId, row.entity.activityId)}}" target="_self">{{row.entity.name}}</a>
									</div>
									`
                    },
                    {
                        field: 'description',
                        cellTemplate: `
									<div class="ui-grid-cell-contents">
										<div class="multi-line-text">{{row.entity.description}}</div>
								    </div>
									`
                    },
                    {
                        field: 'responsibleName',
                        width: '10%',
                        cellTemplate: `
						<div class="ui-grid-cell-contents">
							<div>
								{{row.entity.responsibleName}}
							</div>
							<div class="fs11 dialog-inform-cl margin-bottom-10">
								{{grid.appScope.translation.TaskResponsible}}
							</div>
						</div>
							`
                    },
                    {
                        field: 'responsibleNames',
                        width: '10%'
                    },
                    {
                        field: 'statusDisplay', displayName: 'Status',
                        width: '10%',
                        cellTemplate: `<div class="ui-grid-cell-contents pb10">
											<span ng-if="!row.entity.isSeparateStatus" class="fs12 font-bold" style="padding: 7px 10px;"
												ng-class="{'task-status-grey': row.entity.status == 1,
								                'task-status-warning': row.entity.status == 2, 'task-status-success': row.entity.status == 3, 'task-status-danger': row.entity.status == 4}">{{row.entity.statusDisplay}}
											</span>
                                            <div ng-if="row.entity.isSeparateStatus">
                                                <div class="progress">
                                                    <div class="progress-bar" role="progressbar" aria-valuenow="60" aria-valuemin="0"
                                                         ng-class="{'bg-img-none' : row.entity.numberTotalTasks != 0,  'progress-bar-no-color': row.entity.numberTotalTasks == 0, 'progress-bar-bg-danger': row.entity.numberTotalTasks != 0 && row.entity.numberTasksDone == 0, 'progress-bar-bg-success' : row.entity.numberTotalTasks != 0 && row.entity.numberTasksDone == row.entity.numberTotalTasks, 'progress-bar-bg-warning' : row.entity.numberTasksDone != 0 && row.entity.numberTasksDone < row.entity.numberTotalTasks }"
                                                         aria-valuemax="100"
                                                         style="width: {{ row.entity.numberTasksDone != 0 ? (row.entity.numberTasksDone / row.entity.numberTotalTasks) * 100 : 100 }}%;">
                                                    </div>
                                                </div>
                                                <div>
                                                    {{row.entity.numberTasksDone}}/{{row.entity.numberTotalTasks}}
                                                </div>
                                            </div>
									   </div>`
                    },
                    {
                        field: 'document', displayName: '',
                        width: '45',
                        cellTemplate: `app/components/annualCycle/templates/taskAttachmentsTooltip.html`
                    },
                    {
                        field: 'expand',
                        displayName: '',
                        width: '45'
                    }
                ]
            };
            activity.subGridOptions.data = angular.copy(vm.activityTasks).filter(item => item.activityId == activity.activityId);
            activity.subGridOptions.data.forEach((task) => {
                task.setLoading = false;
                task.generateRelatedTaskDialog = (entity) => {
                    task.setLoading = true;
                    $http.get('/api/Activity/GetActivityTaskRelateds?activityTaskId=' + entity.activityTaskId).success(function (response) {
                        response.name = task.name;
                        task.setLoading = false;
                        var modalInstance = $modal.open({
                            templateUrl: '/app/components/annualCycle/templates/relatedTask.html',
                            controller: 'RelatedTaskController as vm',
                            size: 'lg',
                            backdrop: 'static',
                            resolve: {
                                model: function () {
                                    return {
                                        data: response
                                    }
                                }
                            }
                        });
                    });
                    
                }
            });
            activity.subGridOptions.enableHorizontalScrollbar = uiGridConstants.scrollbars.NEVER;
            activity.subGridOptions.enableVerticalScrollbar = uiGridConstants.scrollbars.NEVER;
            activity.subGridOptions.expandableRowScope = { getTaskDetailUrl: vm.getTaskDetailUrl };
        }

        function generateStatusText(status) {
            switch (status) {
                case 1:
                    return globalResources.NotStarted.toUpperCase();
                case 2:
                    return globalResources.InProgress.toUpperCase();
                case 3:
                    return globalResources.Completed.toUpperCase();
                case 4:
                    return globalResources.Consult.toUpperCase();
                default:
                    return globalResources.NotStarted.toUpperCase();
            }
        }

        function initCycleMonths() {
            vm.cycleMonths.push(
                {
                    months: [
                        { id: 11, name: globalResources.November, 'class': 'bottom-right' },
                        { id: 12, name: globalResources.December, 'class': 'bottom-right' },
                        { id: 1, name: globalResources.January, 'class': 'bottom-left' },
                        { id: 2, name: globalResources.February, 'class': 'bottom-left' },
                    ]
                },
                {
                    months: [
                        { id: 10, name: globalResources.October, 'class': 'bottom-right' },
                        {},
                        {},
                        { id: 3, name: globalResources.March, 'class': 'bottom-left' },
                    ]
                },
                {
                    months: [
                        { id: 9, name: globalResources.September, 'class': 'top-right' },
                        {},
                        {},
                        { id: 4, name: globalResources.April, 'class': 'top-left' },
                    ]
                },
                {
                    months: [
                        { id: 8, name: globalResources.August, 'class': 'top-right' },
                        { id: 7, name: globalResources.July, 'class': 'top-right' },
                        { id: 6, name: globalResources.June, 'class': 'top-left' },
                        { id: 5, name: globalResources.May, 'class': 'top-left' },
                    ]
                });


            vm.cycleSchoolMonths.push(
                {
                    months: [
                        { id: 6, name: globalResources.July, 'class': 'bottom-right' },
                        { id: 7, name: globalResources.June, 'class': 'bottom-right' },
                        { id: 8, name: globalResources.August, 'class': 'bottom-left' },
                        { id: 9, name: globalResources.September, 'class': 'bottom-left' },
                    ]
                },
                {
                    months: [
                        { id: 5, name: globalResources.May, 'class': 'bottom-right' },
                        {},
                        {},
                        { id: 10, name: globalResources.October, 'class': 'bottom-left' },
                    ]
                },
                {
                    months: [
                        { id: 4, name: globalResources.April, 'class': 'top-right' },
                        {},
                        {},
                        { id: 11, name: globalResources.November, 'class': 'top-left' },
                    ]
                },
                {
                    months: [
                        { id: 3, name: globalResources.March, 'class': 'top-right' },
                        { id: 2, name: globalResources.February, 'class': 'top-right' },
                        { id: 1, name: globalResources.January, 'class': 'top-left' },
                        { id: 12, name: globalResources.December, 'class': 'top-left' },
                    ]
                });
        }

        function getPeriods(yearRange) {
            var result = [];
            var currentYear = new Date().getFullYear();
            for (var i = -5; i < yearRange - 5; i++) {
                result.push(currentYear + i);
            }

            return result;
        }

        function getPeriodsForSchoolYear(yearRange) {
            var result = [];
            var currentYear = new Date().getFullYear();
            for (var i = -1; i < yearRange - 1; i++) {
                var year = currentYear + i;
                var nextYear = year + 1;
                result.push({
                    key: year,
                    value: year + ' / ' + nextYear
                });
            }

            return result;
        }

        function getActivityDetailUrl(activityId) {
            if (configService.getBool(HandbookConfiguration.ShowNewAnnualCycleDetailPage)) {
                return String.format('/ac/activity/{0}', activityId);
            }
            return String.format('{0}ac/activity/{1}/edit', HandbookConfiguration.BackendURL, activityId);
        }

        function getTaskDetailUrl(taskId, activityId) {
            if (configService.getBool(HandbookConfiguration.ShowNewAnnualCycleDetailPage)) {
                return String.format('/ac/task/{0}', taskId);
            }
            return String.format('{0}ac/activity/{1}/edit', HandbookConfiguration.BackendURL, activityId);
        }
        //TODO : uncomment when have requirements
        //function updateReadingListReaderTypes(readers) {
        //    for (var i = 0; i < readers.length; i++) {
        //        var reader = readers[i];
        //        switch (reader.readerType) {
        //            case E.readerTypes.Person:
        //                reader.readerTypeName = resources.L.Common.person;
        //                break;
        //            case E.readerTypes.Department:
        //                reader.readerTypeName = resources.L.Common.department;
        //                break;
        //            case E.readerTypes.Role:
        //                reader.readerTypeName = resources.L.Common.role;
        //                break;
        //        }
        //    }
        //}
    }

    function activitiesByMonthFilter() {
        return function (source, month, year) {
            if (!year || !month || !source) {
                return [];
            }
            var result = source.filter(function (activity) {
                var date = new Date(activity.startDate);
                return date.getMonth() == (month - 1) && date.getFullYear() == year;
            })
            return result;
        };
    }

    function activitiesBySchoolYearMonthFilter() {
        return function (source, month, year) {
            if (!year || !month || !source) {
                return [];
            }
            var result = source.filter(function (activity) {
                var date = new Date(activity.startDate);
                var activityYear = date.getFullYear();
                var activityMonth = date.getMonth();
                if (activityYear == year && activityMonth >= 7 && activityMonth == (month - 1)) {
                    return true;
                }
                else if (activityYear == year + 1 && activityMonth <= 6 && activityMonth == (month - 1)) {
                    return true;
                }

                return false;
            })
            return result;
        };
    }

    function filterActivitiesByMonth(source, month, year) {
        if (!year || !month || !source) {
            return [];
        }
        var result = source.filter(function (activity) {
            var date = new Date(activity.startDate);
            return date.getMonth() == (month - 1) && date.getFullYear() == year;
        })
        return result;
    }

    function filterActivitiesBySchoolYearMonth(source, month, year) {
        if (!year || !month || !source) {
            return [];
        }
        var result = source.filter(function (activity) {
            var date = new Date(activity.startDate);
            var activityYear = date.getFullYear();
            var activityMonth = date.getMonth();
            if (activityYear == year && activityMonth >= 7 && activityMonth == (month - 1)) {
                return true;
            }
            else if (activityYear == year + 1 && activityMonth <= 6 && activityMonth == (month - 1)) {
                return true;
            }

            return false;
        })
        return result;
    }
})();

